const HOSTED_UNLOCK_URL = 'https://unlock.payhook.link/'

export function selectPreviewPaymentHook (data) {
  const items = Array.isArray(data?.items) ? data.items : []
  return items.find((item) => typeof item?.id === 'string' && item.id.trim()) || null
}

export function buildHostedUnlockPreviewSelectionKey ({ workspaceId, testMode = false, country = '', experimentView = '' } = {}) {
  return `${workspaceId || ''}:${testMode ? 'test' : 'live'}:${country || 'actual'}:${experimentView || 'assigned'}`
}

export function isHostedUnlockPreviewRequestCurrent ({ selectionKey, activeRequestId }, { key, requestId }) {
  return selectionKey === key && activeRequestId === requestId
}

export function listHostedUnlockExperimentViews (experiments) {
  if (!Array.isArray(experiments)) return []

  return experiments.flatMap((experiment) => {
    if (!experiment?.id || !Array.isArray(experiment.variants)) return []
    return experiment.variants
      .filter((variant) => variant?.name)
      .map((variant, index) => ({
        experimentId: experiment.id,
        experimentStatus: experiment.status || 'draft',
        variantName: variant.name,
        variantLabel: `${String.fromCharCode(65 + index)} · ${variant.name}`,
        value: `${experiment.id}:${variant.name}`
      }))
  })
}

export function parseHostedUnlockExperimentView (value) {
  if (!value || typeof value !== 'string') return null
  const separator = value.indexOf(':')
  if (separator <= 0 || separator === value.length - 1) return null
  return {
    experimentId: value.slice(0, separator),
    variantName: value.slice(separator + 1)
  }
}

export function buildHostedUnlockPreviewUrl ({ paymentHookId, testMode = false, dashboardPreview = false, revision } = {}) {
  if (!paymentHookId) return null

  const url = new URL(HOSTED_UNLOCK_URL)
  url.searchParams.set('paymentHookId', paymentHookId)
  if (testMode) url.searchParams.set('testMode', 'true')
  if (dashboardPreview) url.searchParams.set('preview', 'dashboard')
  if (revision != null) url.searchParams.set('previewRevision', String(revision))
  return url.toString()
}

export function buildHostedUnlockSuccessPreviewUrl ({ paymentHookId, testMode = false, revision } = {}) {
  if (!paymentHookId) return null

  const url = new URL('success/', HOSTED_UNLOCK_URL)
  url.searchParams.set('paymentHookId', paymentHookId)
  if (testMode) url.searchParams.set('testMode', 'true')
  if (revision != null) url.searchParams.set('previewRevision', String(revision))
  return url.toString()
}
